{
	"selectAll": "Seleccionar todas"
}
